import { LOADING, SET_MESSAGE } from "../../Actions/Types";
import {
  bulkDomainListActionAPI,
  checkBulkDomainListAPI,
  AddDomainOnAccount,
  AddDomainSelectedIds,
} from "../../Api/BulkDomainAPI";
import { getUserDetailsService } from "../../Services/UserAction/LoginActionService";

const AddDomainOnAccountService = (
  selectedDomainIds: any,
  accessToken: string, // access token
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function
  navigate: Function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  AddDomainSelectedIds(selectedDomainIds, accessToken).then((response) => {
    if (response.status === 200) {
      // remove Loading
      navigate(`/front/autologin/${response?.Data?.autologin_token}`);
      getUserDetailsService(accessToken, dispatch)
      dispatch({
        type: LOADING,
        payload: false,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.msg),
          toast_type: "success",
        },
      });
    } else {
      // remove Loading
      dispatch({
        type: LOADING,
        payload: false,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(response.error),
          toast_type: "danger",
        },
      });
    }
  });
};

// service to check validity of bulk domains
const checkBulkDomainListService = (
  accessToken: string,
  domainListFile: File,
  dispatch: Function,
  t: Function,
  setValidDomain: Function,
  setInValidDomain: Function,
  setExistDomain: Function,
  setDuplicateDomain: Function,
  isDynamicPlanLimit?: number | null,
  navigate?: Function,
  setAutoLoginToken?: Function,
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // API to validate bulk domains
  checkBulkDomainListAPI(accessToken, domainListFile).then((response) => {
    // check if response data is available
    if (
      (response.data && response.data.length > 0) ||
      (response.invalidDomain && response.invalidDomain.length > 0) ||
      (response.existDomain && response.existDomain.length > 0) ||
      (response.duplicateDomains && response.duplicateDomains.length > 0)
    ) {
      // Set All Data

      // setValidDomain(isDynamicPlanLimit ? response.data.splice(1,isDynamicPlanLimit) : response.data);
      setValidDomain(response.data);
      setInValidDomain(response.invalidDomain);
      setExistDomain(response.existDomain);
      setDuplicateDomain(response.duplicateDomains);
      if (response?.data?.length <= (isDynamicPlanLimit ?? 0)) {
        if (accessToken) {
          // service to perform action on bulk domain
          AddDomainOnAccount(accessToken).then((response) => {
            if (response.status === 200) {
              setAutoLoginToken && setAutoLoginToken(`/front/autologin/${response?.Data?.autologin_token}`);
              getUserDetailsService(accessToken, dispatch)
              dispatch({
                type: SET_MESSAGE,
                payload: {
                  toast_message: t(response.msg),
                  toast_type: "success",
                },
              });
            } else {
              // remove Loading
              dispatch({
                type: LOADING,
                payload: false,
              });

              dispatch({
                type: SET_MESSAGE,
                payload: {
                  toast_message: t(response.error),
                  toast_type: "danger",
                },
              });
            }
          });
          // AddDomainOnAccountService(accessToken, dispatch, t, navigate);
        }
      }
      // remove Loading
      dispatch({
        type: LOADING,
        payload: false,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t("File upload successfully!"),
          toast_type: "success",
        },
      });
    } else {
      // Set All Data
      setValidDomain([]);
      setInValidDomain([]);
      setExistDomain([]);
      setDuplicateDomain([]);

      // remove Loading
      dispatch({
        type: LOADING,
        payload: false,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t(
            "File is blank or invalid. Please check with sample file. Make sure your file header must be domain and plan."
          ),
          toast_type: "danger",
        },
      });
    }
  });
};

// function to perform update on bulk domains
const bulkDomainListActionService = (
  accessToken: string, // access token
  objId: number, // domain id
  domain: string, // domain name
  planId: number, // plan id
  action: string, // action
  dispatch: Function, // dispatch function to store redux data
  t: Function, // i18next t function
  setValidDomain: Function, // function to set list of valid domain
  callBackFunction?: Function // callback function
) => {
  // Set Loading
  dispatch({
    type: LOADING,
    payload: true,
  });

  // api to perform action on bulk domains
  bulkDomainListActionAPI(accessToken, objId, domain, planId, action).then(
    (response) => {
      if (response.data) {
        setValidDomain(response.data);
        callBackFunction && callBackFunction();

        // remove Loading
        dispatch({
          type: LOADING,
          payload: false,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: {
            toast_message: t("Domain successfully updated."),
            toast_type: "success",
          },
        });
      } else {
        // remove Loading
        dispatch({
          type: LOADING,
          payload: false,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: {
            toast_message: t("Domain not updated. please try again."),
            toast_type: "danger",
          },
        });
      }
    }
  );
};

export {
  checkBulkDomainListService,
  bulkDomainListActionService,
  AddDomainOnAccountService,
};
